import ModalController from '../modal_controller.js'
import escapeHtml from '../../utils/sanitize'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import {
  trans,
  ERROR_UNKNOWN,
  ERROR_PERMISSION_DENIED,
  ERROR_BAD_REQUEST
} from '../../translator'

export default class extends ModalController {
  static values = {
    threatCategoryId: String,
    threatCategoryChildren: Array
  }

  static targets = [
    'newThreatCategoryName', 'error'
  ]

  openModal (event, threatCategoryId) {
    this.errorTarget.classList.add('d-none')
    this.newThreatCategoryNameTarget.value = ''
    super.openModal()
  }

  confirmAddThreatCategory () {
    this.errorTarget.classList.add('d-none')
    fetchWithHandlingLoginRedirect(
      '/internal/api/threat-categories',
      {
        method: 'POST',
        body: JSON.stringify({
          name: escapeHtml(this.newThreatCategoryNameTarget.value)
        })
      })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response)
        }

        return response.json()
      })
      .then(data => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = data.renderedThreatCategory
        const newThreatCategory = tempDiv.firstChild

        const threatCategoriesList = document.getElementById('threat-categories-list')
        let inserted = false
        for (const existingThreatCategory of threatCategoriesList.querySelectorAll('div.parent-threat-category')) {
          const currentThreatCategoryName = existingThreatCategory.querySelector('.parent-threat-category-name').textContent.trim().toLowerCase()
          if (this.newThreatCategoryNameTarget.value < currentThreatCategoryName) {
            existingThreatCategory.parentNode.insertBefore(newThreatCategory, existingThreatCategory)
            inserted = true
            break
          }
        }

        if (!inserted) {
          threatCategoriesList.appendChild(newThreatCategory)
        }

        this.closeModal()
        newThreatCategory.scrollIntoView({ behavior: 'smooth', block: 'center' })
        // open kebab menu to prompt user to add children
      })
      .catch(async error => {
        let errorMessage = trans(ERROR_UNKNOWN, {}, 'threat-categories')
        switch (error.status) {
          case 400:
            errorMessage = trans(ERROR_BAD_REQUEST, {}, 'threat-categories')
            break
          case 403:
            errorMessage = trans(ERROR_PERMISSION_DENIED, {}, 'threat-categories')
            break
        }

        this.errorTarget.innerHTML = errorMessage
        this.errorTarget.classList.remove('d-none')
      })
  }
}
